<template>
  <div name="hrms-dropzone" class="hrms-dropzone">
    <vue-dropzone  v-show="dispAttach"
                   :id="name"
                   :url="url"
                   :headers="headers"
                   :useFontAwesome="true"
                   @vdropzone-sending="triggerSending"
                   @vdropzone-removed-file="triggerRemoveFile"
                   @vdropzone-success="triggerSuccessBuiltIn"
                   @vdropzone-error="triggerError"
                   :maxNumberOfFiles="maxNumberOfFiles"
                   :showRemoveLink="showRemoveLink"
                   :maxFileSizeInMB="maxFileSizeInMB"
                   :acceptedFileTypes="acceptedFileTypes"
                   :capture="capture"
                   :ref="'vueDropzoneCall' + name"
                   :resizeMethod="resizeMethod"
                   :resizeWidth="resizeWidth"
                   :resizeHeight="resizeHeight"
                   :class="{ 'input-error' : hasError }"  >
      <input type="hidden" name="token" value="xxx">
      <div v-show="dispAttach" class="text-remark _text-blue">
        <div v-show="!flgEditInline">
          <ul>
            <li>File name must only contain alphanumeric characters with no spaces and hiphen.</li>
            <li>Maximum size of 2 MB is allowed.</li>
          </ul>
        </div>
      </div>
    </vue-dropzone>
    <div v-show="!dispAttach">
      <span v-show="flgPreview" class="img-upload-preview" v-if="['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(getFileExtension(inputFileName))">
        <img :src="filePath + inputFileName">
      </span>
      <span class="img-upload-detail">
        {{ inputFileName }}
        <a class="fa fa-paperclip ico-knowledge1 dash-color-skin" :href="filePath + this.inputFileName" target="_blank" v-show="filePath + this.inputFileName" @click.stop></a>
        <a class="fa fa-trash ico-knowledge1 cursor-pointer" v-show="filePath + this.inputFileName" @click="deleteFileTemp()"></a>
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as types from 'store/modules/hrmsDropzone/mutation-types'
import vueDropzone from 'vue2-dropzone'
// import regex from 'assets/js/regex'
import swal from 'sweetalert'
import env from 'src/../env.js'

const configLabels = require('src/../config/label')

export default {
  name: 'hrms-dropzone',
  data () {
    return {
      dash: this.$root.$children[0].$children[0],
      url: window.localStorage.getItem(env.site + '_baseURL') + 'api/uploader/uploadFile',
      headers: {
        currentUser: this.getCurrentUser(),
        fileDir: this.fileDir
      },
      filePath: '',
      dispAttach: true,
      fileDir: '',
      flgDeleteFile: true,
      inputFileName: this.fileNameQuery,
      inputFileName_: this.fileNameQuery,
      tempFileName: '',
      tempFileName_: '',
      resultFileName: this.value,
      flgLoadSuccess: true,
      baseURL: window.localStorage.getItem(env.site + '_baseURL')
    }
  },
  created () {
    if (this.inputFileName === '') {
      this.dispAttach = true
    } else {
      this.dispAttach = false
    }
    this.setupDir()
  },
  computed: {
    getTfolder () {
      let tfolder = this.dash.getTfolder()
      return tfolder
    }
  },
  watch: {
    'fileNameQuery' () {
      this.clearFileTemp()
      this.inputFileName = this.fileNameQuery
      this.inputFileName_ = this.fileNameQuery
      this.tempFileName = ''
      this.tempFileName_ = ''
    },
    'inputFileName' (newVal) {
      if (this.inputFileName === '') {
        this.dispAttach = true
      } else {
        this.dispAttach = false
      }
    },
    getTfolder () {
      this.setupDir()
    },
    'prefixFileName' () {
      this.headers.currentUser = this.getCurrentUser()
    },
    'flgToggle' () {
      if (!this.flgToggle) {
        if (this.inputFileName && this.inputFileName !== this.inputFileName_) {
          this.callDeleteFile(this.inputFileName)
        } else if (this.tempFileName !== this.tempFileName_) {
          this.callDeleteFile(this.tempFileName)
        }
        this.$nextTick(() => {
          this.tempFileName = ''
          this.tempFileName_ = ''
          this.inputFileName = this.fileNameQuery
          this.inputFileName_ = this.fileNameQuery
          this.clearDropzone()
        })
      }
    }
  },
  mounted () {
    this.$on('$clearDropzone', () => {
      this.clearDropzone()
    })
    this.$on('$clearFileTemp', () => {
      this.clearFileTemp()
    })
  },
  methods: {
    triggerRemoveFile (file) {
      if (this.flgDeleteFile && this.flgLoadSuccess) {
        this.postRemovedFile({ file: file, fileDir: this.headers.fileDir })
      }
      this.resultFileName = ''
      this.triggerReturnFileName(this.resultFileName)
    },
    ...mapActions({
      postRemovedFile: types.POST_HRMS_DROPZONE_REMOVED_FILE
    }),
    removeFileEvent () {
      this.$refs['vueDropzoneCall' + this.name].removeAllFiles()
    },
    triggerSending (file, xhr, formData) {
      // if (!file.name.match(regex.alphabet) && !this.capture) {
        // this.flgDeleteFile = false
        // swal({ title: 'Error', text: 'wrong file name format (only alphabet or number)', status: 'error' })
        // this.removeFileEvent()
      // }
    },
    triggerSuccessBuiltIn (file, response) {
      if (this.flgRename) {
        this.dispAttach = false
      }
      this.triggerSuccess(file, response)
      this.flgLoadSuccess = true
    },
    triggerError (file) {
      if (file.size > 2000000) {
        this.flgDeleteFile = false
        // swal({ title: 'Error', text: 'wrong file name format (only alphabet or number)', status: 'error' })
        swal({ title: 'Error', text: 'File is too big (' + (file.size / 1000000).toFixed(2) + 'MiB). Max filesize: 2MiB.', status: 'error' })
        this.removeFileEvent()
      }
      this.flgDeleteFile = true
      this.flgLoadSuccess = !(file.status === 'error')
    },
    setupDir () {
      if (!this.othPath) {
        if (this.flgPathTemp || this.getTfolder.codapp === '') {
          this.headers.fileDir = 'temp/'
        } else {
          // this.headers.fileDir = this.getTfolder.main + this.getTfolder.folder
          this.headers.fileDir = this.getTfolder.folder
        }
        // this.filePath = this.getTfolder.load + this.getTfolder.folder + '/'
        this.filePath = this.baseURL + 'file_uploads/' + this.getTfolder.folder + '/'
      } else {
        this.headers.fileDir = this.othPath
      }
    },
    getCurrentUser () {
      let objCurrentUser = JSON.parse(configLabels.getCurrentUserHeader())
      objCurrentUser.codapp = this.$route.name
      objCurrentUser.flgrename = this.flgRename ? 'Y' : 'N'
      objCurrentUser.codempidQuery = this.prefixFileName

      return JSON.stringify(objCurrentUser)
    },
    triggerSuccess (file, response) {
      if (this.tempFileName) {
        if (this.tempFileName !== this.tempFileName_) {
          this.callDeleteFile(this.tempFileName)
        }
      }
      this.tempFileName = ''
      this.inputFileName = response.file.new_filename
      let _this = this
      setTimeout(function () {
        _this.resultFileName = response.file.new_filename ? response.file.new_filename : file.name
        _this.triggerReturnFileName(_this.resultFileName)
        _this.uploadSuccess(_this.resultFileName)
      }, 1000)
    },
    callDeleteFile (fileName) {
      this.flgDeleteFile = true
      let file = {
        name: ''
      }
      file.name = fileName
      this.$nextTick(() => {
        this.triggerRemoveFile(file)
      })
    },
    deleteFileTemp () {
      this.tempFileName = this.inputFileName
      this.tempFileName_ = this.inputFileName_
      this.inputFileName = ''
      this.resultFileName = ''
      this.clearDropzone()
      this.uploadSuccess('')
      this.triggerReturnFileName(this.resultFileName)
    },
    clearDropzone () {
      this.flgDeleteFile = false
      this.$nextTick(() => {
        this.removeFileEvent()
      })
    },
    clearFileTemp () {
      if (this.tempFileName) {
        this.callDeleteFile(this.tempFileName)
      }
      if (this.tempFileName_) {
        this.callDeleteFile(this.tempFileName_)
      }
    },
    uploadSuccess (data) {
      this.$emit('uploadSuccess', data)
    },
    triggerReturnFileName (fileName) {
      this.$emit('input', fileName)
    },
    getFileExtension (fileName) {
      return (fileName.substr(fileName.lastIndexOf('.') + 1)).toLowerCase()
    }
  },
  props: {
    value: {
      type: String,
      default () {
        return ''
      }
    },
    fileNameQuery: {
      type: String,
      default () {
        return ''
      }
    },
    flgPathTemp: {
      type: Boolean,
      default () {
        return false
      }
    },
    maxNumberOfFiles: {
      type: Number,
      default: 1
    },
    maxFileSizeInMB: {
      type: Number
    },
    acceptedFileTypes: {
      type: String
    },
    capture: {
      type: String,
      default: null
    },
    showRemoveLink: {
      type: Boolean,
      default: true
    },
    prefixFileName: {
      type: String
    },
    flgRename: {
      type: Boolean,
      default () {
        return true
      }
    },
    flgToggle: {
      type: Boolean,
      default () {
        return false
      }
    },
    othPath: {
      type: String
    },
    name: {
      type: String,
      default () {
        return 'vueDropzone'
      }
    },
    hasError: {
      type: Boolean,
      default: false
    },
    resizeMethod: {
      type: String,
      default: 'contain'
    },
    resizeWidth: {
      type: Number,
      default: null
    },
    resizeHeight: {
      type: Number,
      default: null
    },
    flgEditInline: {
      type: Boolean,
      default: false
    },
    flgPreview: {
      type: Boolean,
      default: false
    }
  },
  components: {
    vueDropzone
  }
}
</script>

<style lang="scss">
  .hrms-dropzone {
    .text-remark {
      font-size: 11px;
    }
    .img-upload-preview {
      margin-right: 20px;
      img {
        max-width: 150px;
        max-height: 150px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// component.vue?53a908ca